<template>
  <section class="sc-report-total-quote__content">
    <sc-field label="Datas (máximo de 30 dias)">
      <sc-range-date-picker
        v-model="dateRange"
        :max-date="maxDate"
        :format="formatDateRange"
        class="inner-content__date-picker"/>
    </sc-field>

    <sc-field label="Tipo de Relatório">
      <sc-select
        placeholder="Selecione"
        v-model="selectedMethod">
        <option
          v-for="report in reports"
          :key="report.value"
          :value="report.value">
          {{ report.label }}
        </option>
      </sc-select>
    </sc-field>

    <div class="sc-report-total-quote__buttons">
      <button
        class="button is-primary sc-report-total-quote__button"
        :class="{ 'is-loading': loading }"
        :disabled="!selectedMethod"
        @click="generateReport">
        Gerar relatório
      </button>

      <router-link
        v-if="hasGeneratedReport"
        class="button is-default sc-report-total-quote__button"
        :to="{ name: 'files-reports', params: { type: 'xlsx' } }">
        Ir para Meus arquivos
      </router-link>
    </div>
  </section>
</template>

<script>
  import { Moment, Lodash } from '@intelipost-js/secure-providers';
  import {
    ScPageBase,
    ScField,
    ScInput,
    ScRangeDatePicker,
    ScIcon,
    ScSelect,
  } from '@intelipost-js/secure-components';
  import { createNamespacedHelpers } from 'vuex';

  const { mapState, mapActions, mapMutations } = createNamespacedHelpers('analytic/totalQuote');

  export default {
    data() {
      return {
        dateRange: Lodash.cloneDeep(this.$store.state.analytic.totalQuote.dateRange),
        maxDate: Moment().toDate(),
        selectedMethod: null,
        reports: [
          {
            label: 'Quantidade de cotações por plataforma e canal de vendas',
            value: 'getTotalQuoteByPlatformAndSalesChannel',
          },
          {
            label: 'Quantidade de pedidos por plataforma',
            value: 'getTotalOrderByPlatform',
          },
          {
            label: 'Quantidade de pedidos por transportadora',
            value: 'getTotalOrderByProvider',
          },
        ],
      };
    },
    watch: {
      dateRange: {
        handler(dateRange) {
          this.setDateRange(dateRange);
        },
        deep: true,
      },
    },
    computed: {
      ...mapState([
        'loading',
        'hasGeneratedReport',
      ]),
    },
    methods: {
      ...mapActions([
        'getTotalQuoteByPlatformAndSalesChannel',
        'getTotalOrderByPlatform',
        'getTotalOrderByProvider',
      ]),
      ...mapMutations([
        'setDateRange',
        'setLoading',
      ]),
      generateReport() {
        const dateRange = {
          start: Moment(this.$store.state.analytic.totalQuote.dateRange.start).format('YYYY-MM-DD'),
          end: Moment(this.$store.state.analytic.totalQuote.dateRange.end).format('YYYY-MM-DD'),
        };

        this[this.selectedMethod](dateRange);
      },
      formatDateRange(dateRange) {
        return {
          start: Moment(dateRange.start).format('YYYY-MM-DD'),
          end: Moment(dateRange.end).format('YYYY-MM-DD'),
        };
      },
    },
    components: {
      ScPageBase,
      ScField,
      ScInput,
      ScRangeDatePicker,
      ScIcon,
      ScSelect,
    },
  };
</script>

<style lang="scss" scoped>
  .sc-report-total-quote {
    &__content {
      margin-top: 45px;
    }

    &__button {
      display: block;
      width: 100%;
      margin-right: 0;
      margin-bottom: 0.5rem;
    }
  }
</style>



// WEBPACK FOOTER //
// node_modules/@intelipost-modules/secure-analytic/features/reports/pages/total-quote/ReportTotalQuote.vue